/**
 * Tipos compartidos del módulo ListComisionist
 */

export type ComisionistFormData = {
  name: string;
  type: 'Formal' | 'Informal';
  dui: string;
  nit: string;
  nrc: string;
  branchOfficeId: string;
  zoneId: number;
  email: string;
  phone: string;
};

export type ComisionistDocument = {
  id?: string;
  type: string;
  fileName: string;
  file?: File;
  uploadedAt?: string;
  url?: string;
};

export type ComisionistHistoryRecord = {
  id: number;
  date: string;
  user: string;
  action: string;
  detail: string;
};

export type ComisionistFormState = {
  data: ComisionistFormData;
  documents: ComisionistDocument[];
  isSubmitting: boolean;
  error: string | null;
  successMessage: string | null;
};

export const REQUIRED_DOCS_FORMAL = ['DUI/NIT', 'NRC', 'Ficha Firmada'];
export const REQUIRED_DOCS_INFORMAL = ['DUI/NIT', 'Ficha Firmada'];

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

// Se removió DOC_TYPE_ICONS porque ahora se usan componentes de Material-UI en ComisionistDocumentsForm.tsx

export const ACTION_BADGE_COLORS: { [key: string]: { bg: string; color: string } } = {
  'CREADO': { bg: '#1565c0', color: '#fff' },
  'DOC CARGADO': { bg: '#2e7d32', color: '#fff' },
  'ENV. FINANZAS': { bg: '#e65100', color: '#fff' },
  'ACTUALIZADO': { bg: '#1a237e', color: '#fff' },
  'ELIMINADO': { bg: '#c62828', color: '#fff' },
};
